export default __webpack_public_path__ + "static/media/pauseReportIcon.417b9777.svg";